<template>
  <div class='fill-over'>
      <Loadding ref='load' class='load-wrap' :submitInfo='`加载数据中...`' />
      <div class='img-wrap'>
        <img  src="../../assets/image/success.png" alt="">
      </div>
      <h4>应聘信息已提交成功</h4>
      <p>亲，来一个小测试吧</p>
      <van-button class='default-btn' block type="info" color='#E39E54' icon="records" :loading="loading" @click.prevent="fillTest">开始测试</van-button>
  </div>
</template>

<script>
import _ from 'lodash'
import { request } from "@/utils/request";
import zxRequest from "@/utils/requestV2";
import API from "@/utils/API";
import { createLinkLog, checkLinkLog } from './utils/common';
import Loadding from "../other/comp/load"
  export default {
    name:'fillOver',
    data() {
      return {
        testUrl: '',
        loading: false
      }
    },
    components:{
      Loadding
    },
    async mounted() {
    },
    methods: {
      getTestUrl: _.debounce(async function() {
        let data = localStorage.getItem("testUrlData");
        if (!data) {
          this.$toast({
            message: "缺少数据，无法生成测试链接",
            duration: 2500,
          });
        }
        let url = await checkLinkLog({params: data});
        if (url) {
          window.location.href = url;
        } else {
          this.loading = true;
          return zxRequest({
            method: "post",
            url: API.ADD_TEST_TAKER,
            data: JSON.parse(data),
          })
            .then(async (res) => {
              let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
              await createLinkLog(data, res.url, loginInfo.talent_id, Number(loginInfo.code));
              this.testUrl = res.url;
              window.location.href = this.testUrl;
            })
            .finally(() => (this.loading = false));
        }
      }, 1000),
      fillTest() {
        this.getTestUrl();
      },
      async checkLinkLog(params) {
        return request({
          method: "post",
          url: API.CHECK_TEST_LINK,
          data: {
            params,
          },
        }).then((res) => {
          return res.data.data ? res.data.data.url : "";
        });
      },
    },
  }
</script>

<style lang="less" scoped>
.fill-over{
  width: 100%;
  max-width: 750px;
  height: 100vh;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
  .img-wrap{
    width: 100%;
    img{
      width: 80px;
    }
  }
  
  h4{
  font-size: 17px;
  font-weight: 500;
  color: #03081A;
  line-height: 16px;
    margin: 16px 0 12px 0;
  }
}
p{
  font-size: 16px;
  font-weight: 600;
  color: #878B99;
  line-height: 14px;
  margin:20px 0 20px 0;
}
.default-btn{
  width: calc(100% - 32px);
  margin: 0 auto;
  font-size: 17px;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 17px;
  border-radius: 5px;
}
</style>
